import { Typography } from "@circleco/compass/components/Typography";
import { useState } from "react";
import InfiniteScroll from "react-infinite-scroll-component";

import { t } from "@/i18n-js/instance";
import { LoaderRow } from "@/react/components/shared/LoaderRow";
import type { ChatRoomMessageSearchResult } from "@/react/types/Chat/ChatRoomMessage";

import { MessageResultItem } from "./MessageResultItem";

interface MessageSearchResultsProps {
  fetchNextPage: () => void;
  hasNextPage: boolean;
  messages: ChatRoomMessageSearchResult[];
  onNavigate?: () => void;
}

export const MessageSearchResults = ({
  messages,
  fetchNextPage,
  hasNextPage,
  onNavigate,
}: MessageSearchResultsProps) => {
  const [activeMessageId, setActiveMessageId] = useState<number | null>(null);
  return (
    <div className="px-4 pb-2">
      <div className="mb-2">
        <Typography variant="label-xs" color="tertiary">
          {messages.length} {t("chat_space.search_messages.results")}
        </Typography>
      </div>
      <InfiniteScroll
        style={{ overflow: "initial", height: "100%" }}
        scrollThreshold={0.8}
        next={fetchNextPage}
        hasMore={hasNextPage}
        loader={<LoaderRow />}
        scrollableTarget="scrollableMessageSearch"
        dataLength={messages?.length || 0}
        className="pb-2"
      >
        <div className="space-y-2">
          {messages.map(message => (
            <MessageResultItem
              key={message.id}
              message={message}
              activeMessageId={activeMessageId}
              setActiveMessageId={setActiveMessageId}
              onNavigate={onNavigate}
            />
          ))}
        </div>
      </InfiniteScroll>
    </div>
  );
};
